import { render } from "./Billing_dashboard.vue?vue&type=template&id=4683afc4&scoped=true"
import script from "./Billing_dashboard.vue?vue&type=script&lang=js"
export * from "./Billing_dashboard.vue?vue&type=script&lang=js"

import "./Billing_dashboard.vue?vue&type=style&index=0&id=4683afc4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4683afc4"]])

export default __exports__